import { FC } from 'react'
import { Text, VStack } from '@chakra-ui/react'
import { primaryColor } from 'theme/foundations/primaryColor'

import { CardBody } from 'components/CustomCard'
interface SelectedBoxCustomProps {
  title: string
  description?: string
  disabled?: boolean
  icon: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>
  isSelected?: boolean
  handleIsPressed: () => void
}

export const SelectedBoxCustom: FC<SelectedBoxCustomProps> = ({
  title,
  description,
  isSelected,
  disabled = false,
  handleIsPressed,
  icon: Icon,
}) => {
  const {
    text: { bgColorText },
  } = primaryColor


  return (
    <CardBody isBorder isSelected={isSelected} p={2}>
      <VStack
        cursor={disabled ? 'not-allowed' : 'pointer'}
        onClick={handleIsPressed}
        w={'full'}
        alignItems={'center'}
        justifyContent={'center'}
        spacing={2}>
        <VStack justifyContent={'center'}>
          {Icon}
        </VStack>
        <VStack spacing={2} {...description && { pb: 4 }}>
          <Text
            variant={'MD'}
            textAlign={'center'}
            color={bgColorText}>
            {title}
          </Text>
          <Text
            variant={'XS'}
            textAlign={'center'}
            color={bgColorText}>
            {description}
          </Text>
        </VStack>
      </VStack>
    </CardBody>

  )
}
